export default __webpack_public_path__ + "static/personality-collaborative-dark-d5af539e63f4b15bec81e0eec580b1cba267800828bf3d041cdba42ff5f85097.png";